var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBookHighlighted = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Impact/Trade-Selection",
    transform: "translate(-328.000000, -334.000000)",
    fill: "#4A90E2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342,340.495596 L336.18187,334 L336.18187,337.87539 L334.944885,337.87539 C331.109283,337.87539 328,341.041082 328,344.946269 L328,347 L328.549438,346.38698 C330.417465,344.303126 333.060623,343.115801 335.831741,343.115801 L336.18187,343.115801 L336.18187,346.991191 L342,340.495596 Z",
    id: "Path"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookHighlighted, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BookHighlighted.32ea4fc5.svg";
export { ForwardRef as ReactComponent };